import { render, staticRenderFns } from "./FormEstaus.vue?vue&type=template&id=538b910e&"
import script from "./FormEstaus.vue?vue&type=script&lang=js&"
export * from "./FormEstaus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports